{% block sw_cms_element_acris_blog_author_date_preview %}
    <div class="sw-cms-el-preview-acris-blog-author-date">
        {{ $tc('acris-blog.elements.blogAuthorDate.preview.content') }}
    </div>
{% endblock %}